import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'user-add-avatar',
    imports: [MatIconModule],
    templateUrl: './user-add-avatar.component.html',
    styleUrl: './user-add-avatar.component.scss'
})
export class UserAddAvatarComponent {}
